import { render, staticRenderFns } from "./data16.vue?vue&type=template&id=5e38c404&scoped=true"
import script from "./data16.vue?vue&type=script&lang=js"
export * from "./data16.vue?vue&type=script&lang=js"
import style1 from "./data16.vue?vue&type=style&index=1&id=5e38c404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38c404",
  null
  
)

export default component.exports